<template>
      <div class="subscriber">
         <div :class="{'mx-9':$vuetify.breakpoint.lgAndUp, 'mx-0': $vuetify.breakpoint.mdAndDown}">
         <v-container>
            <v-toolbar flat color="#F0FFEA" height="30" >
            <v-toolbar-title style="color:#62AE32" class="headline">Policy</v-toolbar-title>
          </v-toolbar>
            
        <v-card class="my-5" flat> 
            <v-card-title>
            <v-text-field
                v-model="search"
                append-icon="mdi-magnify"
                label="Search"
                single-line
                hide-details
                color="#08911B"
            ></v-text-field>
            <v-spacer></v-spacer>
            <v-select outlined :items="policyType" label="select policy type..."  color="#62AE32" v-model="policyStatus" dense class="mt-6" style="width:10%"  @change="onChange($event)"></v-select>
            </v-card-title>
              <v-data-table
                    v-model="selected"
                    :headers="headers"
                    :items="Policy"
                    :items-per-page="10"
                    item-key="name"
                    :search="search"
                    class="pa-5"
                    :loading="loader"
                    no-data-text="No Recent Subscriptions"
                >

                <template v-slot:item.action="{ item }">
                     <v-icon
                        style="color:#FF5F58; cursor: pointer;"
                      class="mr-2 icon-color"
                      @click="getUserById(item.subscription_id)"
                    >
                      mdi-chevron-right
                    </v-icon>
                </template>
                 </v-data-table>
        </v-card>
        
         </v-container>
         </div>
      </div>
</template>



<script>
export default {
   components: {
    },
    data(){
        return{
          search: '',
          policyStatus:'',
          headers: [
          {
            text: 'Policy Holder',
            align: 'left',
            sortable: false,
            value: 'firstname',
          },
              { text: 'Policy Number', value: 'policy_number' },
              { text: 'Policy Status', value: 'status' },
              { text: 'Community', value: 'community_name' },
              { text: '', value: 'action', sortable: false },
          ],
          policyType:['Active Policy', 'Inactive Policy', 'All', 'Expired Policy'],
          loader:false
        }
    },
    computed:{
    Policy(){
        return this.$store.state.policy.policy
      },

    },
    methods:{
      getUserById(id){
        this.$store.dispatch("ViewPolicy", id)
          .then((success)=>{
            console.log(success)
            this.$router.push(`/community/members/viewPolicy/${success.subscription[0].username}`)
          })
          .catch((error)=>{
            console.log(error);
        })
      },
      onChange(event) { 
        
        if (event==="Inactive Policy"){
          this.loader=true
          this.$store.dispatch("PolicyFilters", {
          "isActive":0
          })
          .then((success)=>{
            this.loader=false
          })
          .catch((error)=>{
            this.loader=false
          });     
        }else if(event==="Active Policy"){
          this.loader=true
          this.$store.dispatch("PolicyFilters", {
          "isActive":1
        })
        .then((success)=>{
          this.loader=false
        })
        .catch((error)=>{
          this.loader=false
        });

        }else if(event==="Expired Policy"){
          this.loader=true
          this.$store.dispatch("PolicyExpiredFilters", {
            "isExpired":1
          })
          .then((success)=>{
            this.loader=false
          })
          .catch((error)=>{
            this.loader=false
          });
        }
        else{
          this.$store.dispatch("getPolicies")
          .then((success)=>{
            this.loader=false
          })
          .catch((error)=>{
            this.loader=false  
          });
        }
      },
    },
    created(){
      
      this.$store.dispatch("getPolicies")
      this.loader=true
      .then((success)=>{
        this.loader=false
      })
      .catch((error)=>{
        this.loader=false
      });
    } 
}
</script>


<style scoped>
.title-color{
  color : #62ae32;
}
.subscriber{
    background-color: #f0ffea;
    height: 100%;
    background-size: cover;
}
</style>